import { useMemo } from "react";
import { useQuery } from "urql";
import { GetScheduledItems } from "@/data-access/news-alerts/queries/scheduler-items-queries";
import { transformSchedulerItemsToTableRows } from "@/store/news-alerts/scheduler-items.helpers";

export const useSchedulerTableItems = () => {
  const [{ data, fetching, error }, refetch] = useQuery({
    query: GetScheduledItems,
    variables: {},
    requestPolicy: "network-only",
  });

  const rows = useMemo(
    () => transformSchedulerItemsToTableRows(data?.schedulerItems ?? []),
    [data?.schedulerItems],
  );

  return {
    rows,
    fetching,
    error,
    refetch,
  };
};
